import { useEffect, useMemo, useState } from "react";
import "./App.css";
import { Header } from "./components/header";
import Game from "./components/screenGame";
import Result from "./components/screenResult";
import Start from "./components/screenStart";
import CurrentContext from "./utils/CurrentContext";
import Instructions from "./components/screenInstructions";

function App() {
  const API_URL =
    "https://fw33qbllrenbw2gjbndxe3why40ouega.lambda-url.eu-central-1.on.aws/";
  const [aspectRatio, setAspectRatio] = useState(
    window.innerWidth / window.innerHeight
  );
  const [currentScreen, setCurrentScreen] = useState("start");

  const getRandomSample = (array, sampleSize) => {
    const shuffled = [...array].sort(() => 0.5 - Math.random());
    return shuffled.slice(0, sampleSize);
  };

  const allImagineImages = Array.from({ length: 42 }, (_, i) => ({
    src: `/images/imagine/${i + 1}.jpg`,
    label: "imagine",
  }));

  const allRealImages = Array.from({ length: 37 }, (_, i) => ({
    src: `/images/real/${i + 1}.jpg`,
    label: "real",
  }));

  const [quizImages, setQuizImages] = useState([]);
  const [answers, setAnswers] = useState([]);
  const [scoreStat, setScoreStat] = useState(null);

  const [currentIndex, setCurrentIndex] = useState(1);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  // useEffect(() => {
  //   console.log("aspectRatio", aspectRatio);
  // }, [aspectRatio]);

  // useEffect(() => {
  //   console.log("scoreStat", scoreStat);
  // }, [scoreStat]);

  useEffect(() => {
    const handleResize = () => {
      setAspectRatio(window.innerWidth / window.innerHeight);
    };

    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const uploadUserDetails = () => {
    const correctCount = answers.filter((a) => a.correct).length;
    const percentage = Math.round((correctCount / answers.length) * 100);

    fetch(API_URL, {
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
        Origin: "https://quiz.livefurnish.com",
        Referer: "https://quiz.livefurnish.com/",
      },
      body: JSON.stringify({ name, email, score: percentage }),
    });
    getScoreStats();
  };

  const getScoreStats = async () => {
    try {
      const res = await fetch(API_URL, {
        method: "POST",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json",
          Origin: "https://quiz.livefurnish.com",
          Referer: "https://quiz.livefurnish.com/",
        },
        body: JSON.stringify({ is_percentage: true }),
      });
      const data = await res.json();
      setScoreStat(data);
    } catch (err) {
      console.error("Error fetching score stats:", err);
    }
  };

  const currentContext = useMemo(
    () => ({
      aspectRatio,
      setAspectRatio,
      setCurrentScreen,
      allImagineImages,
      allRealImages,
      getRandomSample,
      quizImages,
      setQuizImages,
      answers,
      setAnswers,
      scoreStat,
      setScoreStat,
      currentIndex,
      setCurrentIndex,
      name,
      setName,
      email,
      setEmail,
      uploadUserDetails,
    }),
    [
      aspectRatio,
      setAspectRatio,
      setCurrentScreen,
      allImagineImages,
      allRealImages,
      getRandomSample,
      quizImages,
      setQuizImages,
      answers,
      setAnswers,
      scoreStat,
      setScoreStat,
      currentIndex,
      setCurrentIndex,
      name,
      setName,
      email,
      setEmail,
    ]
  );

  const screens = {
    start: <Start />,
    instructions: <Instructions />,
    game: <Game />,
    result: <Result />,
  };

  return (
    <CurrentContext.Provider value={currentContext}>
      <div
        className="App"
        style={{ height: "100vh", display: "flex", flexDirection: "column" }}
      >
        <Header />
        <div
          className="contentWrapper"
          style={{
            width: "100%",
            height: "100%",
            // backgroundColor: "aqua",
            flexGrow: "1",
          }}
        >
          {screens[currentScreen]}
        </div>
      </div>
    </CurrentContext.Provider>
  );
}

export default App;
